import React from 'react'
import { Container, ButtonImg, ButtonText, ButtonInner, CountText, ButtonPill, IconWrapper } from './style'
import arrow from '../../assets/stock/LoadMoreButton/arrow-down.svg'

interface LoadMoreButtonProps {
  currentCount: number
  totalCount?: number | null
  onLoadMore: () => void
  isLoading?: boolean
  hasMore?: boolean
  label?: string
  disabled?: boolean
  buttonLabel?: string
  loadingLabel?: string
  className?: string
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  currentCount,
  totalCount = null,
  onLoadMore,
  isLoading = false,
  hasMore = true,
  label = 'itens',
  disabled = false,
  buttonLabel = 'Carregar mais',
  loadingLabel = 'Carregando...',
  className,
}) => {
  const showCount = typeof currentCount === 'number' || typeof totalCount === 'number'
  const countText = typeof totalCount === 'number'
    ? `Mostrando ${currentCount ?? 0} de ${totalCount} ${label}`
    : `Mostrando ${currentCount ?? 0} ${label}`
  const isButtonDisabled = disabled || isLoading || !hasMore

  const handleClick = () => {
    if (isButtonDisabled) return
    onLoadMore()
  }

  if (!hasMore) {
    return (
      <Container className={className}>
        {showCount && <CountText>{countText}</CountText>}
      </Container>
    )
  }

  return (
    <Container className={className}>
      <ButtonPill
        type="button"
        onClick={handleClick}
        disabled={isButtonDisabled}
        aria-disabled={isButtonDisabled}
      >
        <ButtonInner>
          <IconWrapper>
            <ButtonImg src={arrow} alt="Ícone de seta para carregar mais" />
          </IconWrapper>
          <ButtonText>{isLoading ? loadingLabel : buttonLabel}</ButtonText>
        </ButtonInner>
      </ButtonPill>
      {showCount && <CountText>{countText}</CountText>}
    </Container>
  )
}

export default LoadMoreButton
